import {
  APPOINTMENTS_FETCH_REQUEST,
  APPOINTMENTS_FETCH_SUCCESS,
  APPOINTMENTS_FETCH_FAILURE,
  APPOINTMENTS_CREATE_REQUEST,
  APPOINTMENTS_CREATE_SUCCESS,
  APPOINTMENTS_CREATE_FAILURE,
  APPOINTMENTS_UPDATE_REQUEST,
  APPOINTMENTS_UPDATE_SUCCESS,
  APPOINTMENTS_UPDATE_FAILURE,
  APPOINTMENTS_DELETE_REQUEST,
  APPOINTMENTS_DELETE_SUCCESS,
  APPOINTMENTS_DELETE_FAILURE,
  APPOINTMENTS_SET_SELECTED,
  APPOINTMENTS_CLEAR_SELECTED,
  APPOINTMENTS_SET_LOADING,
  APPOINTMENTS_SET_ERROR,
  APPOINTMENTS_CLEAR_ERROR
} from './appointmentsTypes.js';

const initialState = {
  items: [],
  selectedAppointment: null,
  loading: false,
  error: null
};

const appointmentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case APPOINTMENTS_FETCH_REQUEST:
    case APPOINTMENTS_CREATE_REQUEST:
    case APPOINTMENTS_UPDATE_REQUEST:
    case APPOINTMENTS_DELETE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case APPOINTMENTS_FETCH_SUCCESS:
      return {
        ...state,
        items: action.payload,
        loading: false,
        error: null
      };
    
    case APPOINTMENTS_CREATE_SUCCESS:
      return {
        ...state,
        items: [...state.items, action.payload],
        loading: false,
        error: null
      };
    
    case APPOINTMENTS_UPDATE_SUCCESS:
      return {
        ...state,
        items: state.items.map(item =>
          item.id === action.payload.id ? action.payload : item
        ),
        selectedAppointment: state.selectedAppointment?.id === action.payload.id 
          ? action.payload 
          : state.selectedAppointment,
        loading: false,
        error: null
      };
    
    case APPOINTMENTS_DELETE_SUCCESS:
      return {
        ...state,
        items: state.items.filter(item => item.id !== action.payload),
        selectedAppointment: state.selectedAppointment?.id === action.payload 
          ? null 
          : state.selectedAppointment,
        loading: false,
        error: null
      };
    
    case APPOINTMENTS_FETCH_FAILURE:
    case APPOINTMENTS_CREATE_FAILURE:
    case APPOINTMENTS_UPDATE_FAILURE:
    case APPOINTMENTS_DELETE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    
    case APPOINTMENTS_SET_SELECTED:
      return {
        ...state,
        selectedAppointment: action.payload
      };
    
    case APPOINTMENTS_CLEAR_SELECTED:
      return {
        ...state,
        selectedAppointment: null
      };
    
    case APPOINTMENTS_SET_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    
    case APPOINTMENTS_SET_ERROR:
      return {
        ...state,
        error: action.payload
      };
    
    case APPOINTMENTS_CLEAR_ERROR:
      return {
        ...state,
        error: null
      };
    
    default:
      return state;
  }
};

export default appointmentsReducer;